import { FastArrowDown } from "iconoir-react";

import { createIcon } from "../create-icon";

export const IconFastArrowDown12Line = createIcon(FastArrowDown, 12, "Line");
export const IconFastArrowDown16Line = createIcon(FastArrowDown, 16, "Line");
export const IconFastArrowDown20Line = createIcon(FastArrowDown, 20, "Line");
export const IconFastArrowDown24Line = createIcon(FastArrowDown, 24, "Line");
export const IconFastArrowDown32Line = createIcon(FastArrowDown, 32, "Line");
export const IconFastArrowDown48Line = createIcon(FastArrowDown, 48, "Line");
export const IconFastArrowDown64Line = createIcon(FastArrowDown, 64, "Line");
